export default __webpack_public_path__ + "static/media/fivedot.0402721e.png";